"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formWrapper = _interopRequireDefault(require("../formWrapper.js"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy3"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _generateNewId = require("../../helpers/generateNewId");
var _settings = require("./Table/settings.js");
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _reducer = _interopRequireWildcard(require("./Table/reducer.js"));
var _reactRedux = require("react-redux");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _Preview = require("./Table/Preview");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _excluded = ["setFieldValue", "values"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Fortress = window.cccisd.fortress;
var Boilerplate = window.cccisd.boilerplate;
var appDefs = window.cccisd.appDefs;
var hasQuestProjectGroup = (0, _get2["default"])(appDefs, 'pawn.groups', []).some(function (group) {
  return group.handle === 'questproject';
});
var levelMap = {};
_settings.levelList.forEach(function (item) {
  levelMap[item.value] = item.label;
});
var rowsMap = {};
var _loop = function _loop() {
  var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
    level = _Object$entries$_i[0],
    info = _Object$entries$_i[1];
  rowsMap[level] = {};
  info.rows.forEach(function (item) {
    rowsMap[level][item.value] = item.label;
  });
};
for (var _i = 0, _Object$entries = Object.entries(_settings.levels); _i < _Object$entries.length; _i++) {
  _loop();
}
var TablesForm = function TablesForm(props) {
  var Link = props.Link,
    settings = props.settings,
    updateSettings = props.updateSettings,
    options = props.options;
  var projectId = (0, _get2["default"])(options, 'customTables.projectId') || 0;
  var projects = (0, _reactRedux.useSelector)(function (state) {
    return state.tableEditor.projects;
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!projects && hasQuestProjectGroup) {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return dispatch((0, _reducer.loadProjects)());
            case 3:
              setLoading(false);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }, []);
  var addTable = function addTable(values, closeModal) {
    var columns = function () {
      var levelInfo = appDefs.pawn[values.level].find(function (item) {
        return item.handle === values.rows;
      });
      if (levelInfo.importantFields && levelInfo.importantFields.length > 0) {
        var columnTree = (0, _settings.getFlatColumnTree)(values.level, values.rows);
        return levelInfo.importantFields.filter(function (field) {
          return field.path in columnTree;
        }).map(function (field, index) {
          return {
            id: index + 1,
            name: field.path,
            query: field.path,
            label: field.label,
            type: columnTree[field.path].type,
            alignment: 'left',
            filter: true,
            sort: true
          };
        });
      }
      return _settings.levels[values.level].initialColumns;
    }();
    updateSettings({
      list: [].concat(_toConsumableArray(settings.list || []), [{
        id: (0, _generateNewId.generateNewId)({
          prefix: 'table',
          settings: settings.list
        }),
        projectId: values.projectId,
        title: values.title,
        notes: values.notes,
        level: values.level,
        rows: values.rows,
        perPage: 50,
        showRowNumbers: false,
        useTaskMaster: false,
        columns: columns
      }])
    });
    closeModal();
  };
  var addTableValidate = function addTableValidate(values) {
    var errors = {};
    if (!values.title) {
      errors.title = 'Title is required';
    }
    return errors;
  };
  var duplicateTable = function duplicateTable(id) {
    var duplicatedTable = (0, _cloneDeep2["default"])(settings.list.find(function (item) {
      return item.id === id;
    }));
    updateSettings({
      list: [].concat(_toConsumableArray(settings.list), [_objectSpread(_objectSpread({}, duplicatedTable), {}, {
        id: (0, _generateNewId.generateNewId)({
          prefix: 'table',
          settings: settings.list
        })
      })])
    });
  };
  var deleteTable = function deleteTable(id) {
    updateSettings({
      list: settings.list.filter(function (item) {
        return item.id !== id;
      })
    });
  };
  var whitelistAllQueries = function whitelistAllQueries() {
    (0, _cccisdConfirm["default"])({
      message: 'Are you sure?'
    }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var errorCount, _iterator, _step, tableSettings;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setLoading(true);
            errorCount = 0;
            _iterator = _createForOfIteratorHelper(settings.list);
            _context2.prev = 3;
            _iterator.s();
          case 5:
            if ((_step = _iterator.n()).done) {
              _context2.next = 17;
              break;
            }
            tableSettings = _step.value;
            _context2.prev = 7;
            _context2.next = 10;
            return _cccisdAxios["default"].post(Boilerplate.route('graphql.whitelist'), {
              handle: "customTable_".concat(tableSettings.id),
              query: (0, _Preview.getQuery)(tableSettings),
              targetedPermissionGroupId: tableSettings.projectId || null
            });
          case 10:
            _context2.next = 15;
            break;
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](7);
            errorCount++;
          case 15:
            _context2.next = 5;
            break;
          case 17:
            _context2.next = 22;
            break;
          case 19:
            _context2.prev = 19;
            _context2.t1 = _context2["catch"](3);
            _iterator.e(_context2.t1);
          case 22:
            _context2.prev = 22;
            _iterator.f();
            return _context2.finish(22);
          case 25:
            setLoading(false);
            (0, _cccisdNotification["default"])({
              message: /*#__PURE__*/_react["default"].createElement("div", null, "All queries have been whitelisted", /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  marginTop: '0.5em'
                }
              }, "Succeed: ".concat(settings.list.length - errorCount), /*#__PURE__*/_react["default"].createElement("br", null), "Failed: ".concat(errorCount)))
            });
          case 27:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 19, 22, 25], [7, 12]]);
    })));
  };
  var columns = [{
    name: 'actions',
    label: 'Actions',
    "class": 'text-center',
    render: function render(value, row) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-success btn-xs",
        onClick: function onClick() {
          return duplicateTable(row.id);
        }
      }, /*#__PURE__*/_react["default"].createElement(_copy["default"], null)), ' ', /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        title: /*#__PURE__*/_react["default"].createElement(_cross["default"], null),
        className: "btn btn-danger btn-xs",
        isConfirm: true,
        confirmationMessage: "Are you sure you want to delete table \"".concat(row.title, "\""),
        onClick: deleteTable.bind(null, row.id)
      }));
    }
  }, {
    name: 'title',
    label: 'Title',
    render: function render(value, row) {
      return /*#__PURE__*/_react["default"].createElement(Link, {
        path: "list[".concat(row.index, "]")
      }, value);
    },
    filter: true,
    sort: true
  }, {
    name: 'notes',
    label: 'Notes',
    filter: true,
    sort: true
  }, {
    name: 'level',
    label: 'Level',
    filter: true,
    sort: true
  }, {
    name: 'rows',
    label: 'Rows',
    filter: true,
    sort: true
  }, {
    name: 'projectTitle',
    label: 'Project',
    filter: true,
    sort: true
  }];
  var data = settings.list.map(function (item, index) {
    return {
      index: index,
      projectId: item.projectId,
      projectTitle: projects && projects[item.projectId] ? projects[item.projectId] : '-',
      id: item.id,
      title: item.title,
      notes: item.notes,
      level: levelMap[item.level],
      rows: rowsMap[item.level][item.rows]
    };
  }).filter(function (item) {
    return projectId ? item.projectId === projectId : true;
  });
  return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: loading
  }, /*#__PURE__*/_react["default"].createElement("h2", null, "Tables"), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary"
    }, "Add Table"),
    title: "Add New Table",
    render: function render(_ref3) {
      var closeModal = _ref3.closeModal;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: {
          projectId: projectId,
          title: '',
          notes: '',
          level: _settings.levelList[0].value,
          rows: _settings.levels[_settings.levelList[0].value].rows[0].value
        },
        onSubmit: function onSubmit(values) {
          return addTable(values, closeModal);
        },
        validate: addTableValidate,
        render: function render(_ref4) {
          var setFieldValue = _ref4.setFieldValue,
            values = _ref4.values,
            other = _objectWithoutProperties(_ref4, _excluded);
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "title",
            component: _cccisdFormik.CccisdInput,
            label: "Title",
            autoFocus: true
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "notes",
            component: _cccisdFormik.CccisdInput,
            label: "Notes"
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "level",
            component: _cccisdFormik.CccisdSelect,
            label: "Level",
            options: _settings.levelList,
            style: {
              width: 'auto'
            },
            onChange: function onChange(event) {
              var value = event.target.value;
              setFieldValue('level', value);
              setFieldValue('rows', _settings.levels[value].rows[0].value);
            }
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "rows",
            component: _cccisdFormik.CccisdSelect,
            label: "Rows",
            options: _settings.levels[values.level].rows,
            style: {
              width: 'auto'
            }
          }), /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-primary",
            type: "submit"
          }, "Add Table"));
        }
      });
    }
  }), Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    style: {
      marginLeft: '0.5em'
    },
    className: "btn btn-primary",
    onClick: whitelistAllQueries
  }, "Whitelist all queries"), settings.list.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
    columns: columns,
    data: data,
    showPerPageOptions: false
  })));
};
var _default = exports["default"] = (0, _formWrapper["default"])()(TablesForm);
var store = window.cccisd && window.cccisd.store;
if (store) {
  if (!store.getState().tableEditor) {
    store.injectReducer('tableEditor', _reducer["default"]);
  }
} else if (process.env.NODE_ENV !== 'test') {
  console.error('There is no redux store at window.cccisd');
}